'use client';

import { ErrorMessage } from '@ifa/ui/error';

export default function ErrorPage() {
    return <ErrorMessage />;
}
